export default __webpack_public_path__ + "static/media/__stars_bg_m.58f85c19.png";